import type { HTMLAttributes } from 'react';
import { cx } from '../../lib/cx';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Inner padding. `none` for cards that host their own rows (lists, tables). */
  padding?: 'none' | 'md' | 'lg';
  /**
   * `panel` is the card of the staff workspace pages (Figma A03.2, A04.2, A05.x): 20px radius and the lifted shadow of
   * the table card, with no border.
   */
  tone?: 'default' | 'panel';
}

const PADDING = { none: '', md: 'p-(--mbm-space-5)', lg: 'p-(--mbm-space-6)' } as const;

/** Surface card: fewer, bigger cards with a soft border and at most a subtle shadow (KT §5.1). */
export function Card({ padding = 'md', tone = 'default', className, ...props }: CardProps) {
  return (
    <div
      className={cx(
        tone === 'panel'
          ? 'rounded-(--mbm-component-radius-card) bg-surface-card shadow-(--mbm-shadow-table-card)'
          : 'rounded-(--mbm-radius-lg) border border-border-line bg-surface-card shadow-(--mbm-shadow-sm)',
        PADDING[padding],
        className,
      )}
      {...props}
    />
  );
}
